import { useEnterAction } from '../lib/useEnterAction';
import type { PreparedRound } from '../lib/lessonGenerator';

interface ImageryPreRoundProps {
  round: PreparedRound;
  onStart: () => void;
}

const PHASE_HINTS: Record<number, string> = {
  0: 'Ordene står roligt. Skriv når du er klar — du ser hvert bogstav du taster.',
  1: 'Samme ord — et sekunds blink, derefter prikker og skriv.',
  2: 'Lyt til hvert ord. Skriv uden at se det.',
};

export default function ImageryPreRound({ round, onStart }: ImageryPreRoundProps) {
  useEnterAction(onStart);
  const hint = PHASE_HINTS[round.index] ?? '';

  return (
    <div className="mx-auto w-full max-w-xl animate-fade-in-up px-4 py-8 text-center">
      <p className="text-xs font-medium tracking-[0.2em] uppercase text-stone-400 dark:text-stone-500">
        Runde {round.index + 1}
      </p>
      <h2 className="mt-3 text-2xl font-light text-strong">
        {round.template.title}
      </h2>
      <p className="mt-4 text-sm leading-relaxed text-muted">
        {round.template.purpose}
      </p>
      {hint && (
        <p className="mt-3 text-xs leading-relaxed text-faint">{hint}</p>
      )}
      <button
        type="button"
        autoFocus
        onClick={onStart}
        className="mt-8 rounded-full border border-stone-300 bg-stone-50 px-8 py-3 text-sm font-medium text-stone-800 transition hover:bg-stone-100 dark:border-stone-600 dark:bg-stone-800/60 dark:text-stone-100 dark:hover:bg-stone-800"
      >
        Start runden
      </button>
      <p className="mt-2 text-xs text-faint">Enter</p>
    </div>
  );
}
